import type { TableHeaderRow } from '@shared/table-generator';

// NOTE: header is belong with component instead of container because it's bound with TableBody of FormSingleQuestionChangeTable
export const singleQuestionChangeTableHeaders: TableHeaderRow[] = [
  {
    children: [
      {
        id: 'question-change-checkbox',
        children: null,
        rowSpan: 1,
        sx: {
          width: '48px',
        },
      },
      {
        id: 'question-change-qid',
        children: 'QID',
        align: 'center',
        rowSpan: 1,
        sx: {
          flex: 1,
        },
      },
      {
        id: 'question-change-difficulty',
        children: 'ระดับความยาก',
        align: 'center',
        rowSpan: 1,
        sx: {
          width: '128px',
        },
      },
      {
        id: 'question-change-question-type',
        children: 'ประเภทข้อสอบ',
        align: 'center',
        rowSpan: 1,
        sx: {
          width: '128px',
        },
      },
      {
        id: 'question-change-question-status',
        children: 'สถานะการใช้งาน',
        align: 'center',
        rowSpan: 1,
        sx: {
          width: '160px',
        },
      },
      {
        id: 'question-change-action',
        children: 'Action',
        align: 'center',
        rowSpan: 1,
        sx: {
          width: '124px',
        },
      },
    ],
  },
];
